import useIsNA from "@dana/Common/Hooks/useIsNA";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const cart = getCartState(state, state.pages.onePageCheckoutConfirmation.cartId)?.value;
    return {
        cart,
        isNA: useIsNA(state),
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface OnePageCheckoutConfirmationPaymentMethodStyles {
    container?: InjectableCss;
    paymentMethodTitleText?: TypographyPresentationProps;
    paymentMethodText?: TypographyPresentationProps;
    paymentMethodTextWrapper?: InjectableCss;
}

export const paymentMethodStyles: OnePageCheckoutConfirmationPaymentMethodStyles = {
    container: {
        css: css`
            flex-direction: column;
            margin-top: 15px;
        `,
    },
    paymentMethodTitleText: {
        variant: "h6",
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = paymentMethodStyles;

const OnePageCheckoutConfirmationPaymentMethod = ({ cart,isNA }: Props) => {
    if (!cart) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <Typography as="h3" {...styles.paymentMethodTitleText}>
                {translate("Purchase Order Number")}
            </Typography>
            <StyledWrapper {...styles.paymentMethodTextWrapper}>
                <Typography {...styles.paymentMethodText}>
                    <strong>{translate("Primary PO No.")}:</strong> {cart.poNumber}
                </Typography>
                {cart.customerVatNumber !== "" && (
                    <Typography {...styles.paymentMethodText}>
                        <strong>{translate("Secondary PO No.")}:</strong>
                        {cart.customerVatNumber}
                    </Typography>
                )}
                {isNA && (
                <Typography {...styles.paymentMethodText}>
                    <strong>{translate("Ship Complete")}:</strong> {cart.properties.shipComplete==='true'?translate("Yes"):translate("No")}
                </Typography>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OnePageCheckoutConfirmationPaymentMethod),
    definition: {
        displayName: "Payment Method",
        group: "One Page Checkout Confirmation",
        allowedContexts: ["OnePageCheckoutConfirmationPage"],
    },
};

export default widgetModule;
